import type { SupplierCapitalEquipment } from '@tandemone/types'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table'

import { ProfileEmpty } from './profile-empty'
import { ProfileSection } from './profile-section'

export function ProfileEquipment({
  companyName,
  rows
}: {
  companyName: string
  rows: SupplierCapitalEquipment[]
}) {
  return (
    <ProfileSection title={`${companyName} Capital Equipment`}>
      {rows.length === 0 ? (
        <ProfileEmpty message='No capital equipment listed.' />
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Equipment</TableHead>
              <TableHead className='text-right'>Quantity</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.id}>
                <TableCell className='font-medium break-words whitespace-normal'>
                  {row.equipmentType}
                </TableCell>
                <TableCell className='text-right tabular-nums'>
                  {row.quantity}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </ProfileSection>
  )
}
